import {Regulation, RegulatoryDocument, Workflow, WorkflowStatus} from 'types';

const RegulatoryDocumentMockup = {
	type: 'RegulatoryDocument' as const,
	id: 'UmVndWxhdG9yeURvY3VtZW50CmQ2Nzk3M2VmMDE0MDk5ZDNhOGQxZDdhOTY=',
	name: 'Pablo Reg Doc 28',
	modifiedAt: '2025-01-27T09:17:03.217Z',
	createdAt: '2025-01-28T09:14:08.217Z',
	createdBy: {
		name: 'Tester Pablo',
		id: 'VXNlclxuZDAwMDAwMDAwLTAwMDAtMDAwMC0wMDAwLTAwMDAwMDAwMTIzNA==',
	},
	modifiedBy: {
		name: 'Tester Pablo',
		id: 'VXNlclxuZDAwMDAwMDAwLTAwMDAtMDAwMC0wMDAwLTAwMDAwMDAwMTIzNA==',
	},
	regulation: {
		name: 'RegulationName',
		id: 'UmVndWxhdGlvbgpkNjc3M2I0MDM4MjIwMDA5YzdiNzRlNDg1',
		regulationNumber: 'Pablo Regulation 05',
		__typename: 'Regulation' as const,
	},
	workflow: {
		__typename: 'Workflow' as const,
		message: 'message',
		clearingVKO: [],
		reapprovingVKO: {
			name: 'Reapprover Pablo',
			id: 'VXNlclxuZDAwMDAwMDAwLTAwMDAtMDAwMC0wMDAwLTAwMDAwMDAwMTIzNA==',
		},
		status: WorkflowStatus.New,
	},
	hidden: false,
};

export type VkoApproverDashboardItemType = Pick<
	RegulatoryDocument,
	'id' | 'name' | 'modifiedAt' | 'createdBy' | 'modifiedBy' | 'createdAt'
> & {
	regulation?:
		| Pick<Regulation, 'id' | 'name' | 'regulationNumber' | '__typename'>
		| undefined
		| null;
} & {
	workflow: Pick<
		Workflow,
		'status' | '__typename' | 'message' | 'clearingVKO' | 'reapprovingVKO'
	>;
};

const generateVkoApproverItems = (
	startIndex: number,
	count: number,
	status: WorkflowStatus,
	modifiedAt?: string,
): VkoApproverDashboardItemType[] => {
	const ret: VkoApproverDashboardItemType[] = [];
	for (let i = startIndex; i < startIndex + count; i++) {
		ret.push({
			...RegulatoryDocumentMockup,
			id: 'FakeID_' + i,
			name: 'Pablo Reg Doc ' + i,
			workflow: {
				...RegulatoryDocumentMockup.workflow,
				status,
			},
			modifiedAt: modifiedAt ?? RegulatoryDocumentMockup.modifiedAt,
		});
	}

	return ret;
};

export const VkoApproverItemsMockup: {
	regulatoryDocuments: VkoApproverDashboardItemType[];
} = {
	regulatoryDocuments: [
		...generateVkoApproverItems(27, 3, WorkflowStatus.New),
		...generateVkoApproverItems(
			30,
			1,
			WorkflowStatus.New,
			'2025-01-20T09:17:03.217Z',
		),
		...generateVkoApproverItems(31, 4, WorkflowStatus.QualityControlInternal),
		...generateVkoApproverItems(35, 4, WorkflowStatus.InProgressInternal),
		...generateVkoApproverItems(
			39,
			1,
			WorkflowStatus.InProgressInternal,
			'2025-01-21T09:17:03.217Z',
		),
		...generateVkoApproverItems(40, 7, WorkflowStatus.Modified),
	],
};
